import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import { useMemo } from "react";

type Props = {
  itemId: number;
  goToDetails: (id: number) => void;
  onModify: (id: number) => void;
};

const DropdownOptionsProject: React.FC<Props> = ({
  itemId,
  goToDetails,
  onModify,
}) => {
  const items = useMemo(() => {
    const _items: MenuProps["items"] = [
      {
        key: "view",
        label: (
          <a onClick={(e) => { e.stopPropagation(); goToDetails(itemId); }}>
            Voir le projet
          </a>
        ),
      },
      {
        key: "modify",
        label: (
          <a onClick={(e) => { e.stopPropagation(); onModify(itemId); }}>
            Modifier le projet
          </a>
        ),
      },
    ];

    return _items;
  }, [itemId, goToDetails, onModify]);

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Button
        type="link"
        icon={<MoreOutlined />}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default DropdownOptionsProject;
